/* tslint:disable */
/* eslint-disable */
/**
 * Auth Service API
 * Auth Service API documentation
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CreatePermissionDtoAuthMethodRestrictionEnum = {
    Pin: 'pin'
};
/**
 * Check if a given object implements the CreatePermissionDto interface.
 */
export function instanceOfCreatePermissionDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('description' in value) || value['description'] === undefined)
        return false;
    if (!('resource' in value) || value['resource'] === undefined)
        return false;
    if (!('operation' in value) || value['operation'] === undefined)
        return false;
    return true;
}
export function CreatePermissionDtoFromJSON(json) {
    return CreatePermissionDtoFromJSONTyped(json, false);
}
export function CreatePermissionDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'description': json['description'],
        'resource': json['resource'],
        'operation': json['operation'],
        'authMethodRestriction': json['authMethodRestriction'] == null ? undefined : json['authMethodRestriction'],
    };
}
export function CreatePermissionDtoToJSON(json) {
    return CreatePermissionDtoToJSONTyped(json, false);
}
export function CreatePermissionDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'description': value['description'],
        'resource': value['resource'],
        'operation': value['operation'],
        'authMethodRestriction': value['authMethodRestriction'],
    };
}
//# sourceMappingURL=CreatePermissionDto.js.map